const SERVER_URL = {
    DEVELOPMENT: 'http://localhost:3001/api/huesik_tower',
    PRODUCTION: 'https://api.kosirock.co.kr/api/huesik_tower'
};

const REG_EXP = {
    EMAIL: /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/,
    PASSWORD: /^(?=.*[a-zA-z])(?=.*[0-9])(?=.*[$`~!@$!%*#^?&\\(\\)\-_=+]).{8,16}$/,
    PHONE: /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/,
    NUMBER: /[^0-9]/g
};

const COMPANY_INFORMATION = {
    NAME: "(주)휴식",
    EMAIL: "official@huesik.co.kr",
    PHONE_NO: "02-911-9051",
    ADDRESS: "서울특별시 노원구 월계동 380-8",
    BUSINESS_NUMBER: "646-86-01056",
    BUILDING: "HUESIK IN GROVE",
    ACCOUNT_NUMBER: "예금주 : 주식회사 휴식, 하나은행 444-910021-18004",
    // ACCOUNT_NUMBER: "예금주 : 주식회사 휴식, 기업 204-107074-04-127",
    KAKAO_LINK: "https://open.kakao.com/me/huesik",
    INSTAGRAM_LINK: "https://www.instagram.com/huesik_residence",
    FACEBOOK_LINK: "https://www.facebook.com/%ED%9C%B4%EC%8B%9D-997267877139835",
    BLOG_LINK: "https://blog.naver.com/kosirock2",
    // ADMIN_PHONE_NO : "010-8666-5833",
    // ADMIN_NAME : "박강현",
    ADMIN_PHONE_NO : "010-4661-9138",
    ADMIN_NAME : "백대선"
    // ADMIN_PHONE_NO : "010-2083-0690",
    // ADMIN_NAME : "김인석"
};

const GUEST_INFO = {
    EMAIL: "guest@huesik.co.kr"
};

export {
    SERVER_URL,
    REG_EXP,
    COMPANY_INFORMATION,
    GUEST_INFO
};